import type { LobbyServerEvent } from '@danda/shared';
import { handleErrorEvent } from './events/error-events';
import { handleSessionEvents } from './events/session-events';
import { handlePartyEvents } from './events/party-events';
import { handleNpcEvents } from './events/npc-events';
import { handleCharacterEvents } from './events/character-events';
import { handleInviteEvents } from './events/invite-events';
import { handleDmEvents } from './events/dm-events';
import { handleFriendEvents } from './events/friend-events';
import { handleDecisionEvents } from './events/decision-events';
import { handleGameEvents } from './events/game-events';
import { handleBackgroundEvents } from './events/background-events';
import { handleLobbyAudioMessage } from '@/lib/audio/audio-routing';
import type { LobbyState } from './lobbyStore.types';
import type { LobbySet } from './events/lobby-event-types';

export type { LobbySet } from './events/lobby-event-types';

export function handleLobbyEventFactory(get: () => LobbyState, set: LobbySet) {
  const ctx = { get, set };
  return (event: LobbyServerEvent): void => {
    // Audio messages are server-pushed soundtrack / FX directives —
    // they don't touch lobby state, so route them straight to the
    // SoundtrackEngine before the rest of the dispatch ladder.
    if (handleLobbyAudioMessage(event)) return;
    if (handleErrorEvent(event, ctx)) return;
    if (handleSessionEvents(event, ctx)) return;
    if (handlePartyEvents(event, ctx)) return;
    if (handleNpcEvents(event, ctx)) return;
    if (handleCharacterEvents(event, ctx)) return;
    if (handleInviteEvents(event, ctx)) return;
    if (handleDmEvents(event, ctx)) return;
    if (handleFriendEvents(event, ctx)) return;
    if (handleDecisionEvents(event, ctx)) return;
    if (handleGameEvents(event, ctx)) return;
    if (handleBackgroundEvents(event, ctx)) return;
  };
}
